/**
 * Image Text Split Section
 * Handles video autoplay and intersection observer for performance
 */

class ImageTextSplit {
  constructor(element) {
    this.element = element;
    this.videos = this.element.querySelectorAll('.image-text-split__video-element');
    
    if (this.videos.length > 0) {
      this.init();
    }
  }

  init() {
    // Ensure videos autoplay when in viewport
    this.setupIntersectionObserver();
    
    // Force autoplay on page load
    this.videos.forEach(video => {
      this.playVideo(video);
    });
  }

  playVideo(video) {
    if (video && video.paused) {
      const playPromise = video.play();
      
      if (playPromise !== undefined) {
        playPromise.catch(error => {
          // Auto-play was prevented, video will play when user interacts
          console.log('Video autoplay prevented:', error);
        });
      }
    }
  }

  pauseVideo(video) {
    if (video && !video.paused) {
      video.pause();
    }
  }

  setupIntersectionObserver() {
    const options = {
      root: null,
      rootMargin: '50px',
      threshold: 0.1
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target;
        
        if (entry.isIntersecting) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      });
    }, options);

    this.videos.forEach(video => {
      observer.observe(video);
    });
  }
}

// Initialize all sections when DOM is ready
function initImageTextSplitSections() {
  const sections = document.querySelectorAll('.image-text-split-wrapper');
  sections.forEach(section => {
    new ImageTextSplit(section);
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageTextSplitSections);
} else {
  initImageTextSplitSections();
}

// Re-initialize when Shopify section is loaded (for theme editor)
document.addEventListener('shopify:section:load', function(event) {
  const section = event.target.querySelector('.image-text-split-wrapper');
  if (section) {
    new ImageTextSplit(section);
  }
});
